import React, { Component } from 'react';
import Donations from './Donations';
import DropForm from './DropForm';
import FAQ from './FAQ';
import logo from './assets/bright-logo.png';
import './App.css';

class App extends Component {
  render() {
    return (
      <div className="app">
        <div className="app__header">
          <img src={logo} className="app__logo" alt="logo" />
        </div>
        <DropForm />
        <FAQ />
        <Donations />
      </div>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js